import { render, staticRenderFns } from "./CommonViewLimited.vue?vue&type=template&id=4ed2a886&scoped=true&"
import script from "./CommonViewLimited.vue?vue&type=script&lang=js&"
export * from "./CommonViewLimited.vue?vue&type=script&lang=js&"
import style0 from "./CommonViewLimited.vue?vue&type=style&index=0&id=4ed2a886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2a886",
  null
  
)

export default component.exports